import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const Tick = (props: IconProps) => (
  <Icon
    width='13'
    height='9'
    viewBox='0 0 13 9'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2 5L5 8L11 2'
      strokeWidth='2'
      strokeLinecap='square'
      strokeLinejoin='round'
    />
    <path
      d='M2 5L5 8L11 2'
      strokeWidth='2'
      strokeLinecap='square'
      strokeLinejoin='round'
    />
  </Icon>
);
